export interface CartState {
  payload: {
    itemsInCart: number | null
  };
  loading: boolean;
  error: string | null;
  showMiniCart?: boolean;
}

export const cartInitialState: CartState = {
  payload: {
    itemsInCart: null
  },
  loading: false,
  error: null,
  showMiniCart: false
};
